export const WHATS_NEW_VERSION = "whats_new_v2";

// Deployment date (change this on deployment day)
export const WHATS_NEW_DEPLOY_DATE = "2026-03-09";

// Banner expiry in days
export const WHATS_NEW_EXPIRY_DAYS = 3;
 
export const WHATS_NEW_CONTENT = [
  {
    section: "Appointments",
    items: [
      "Display of next available slots when creating or editing appointments.",
      "Added manual appointment confirmation indicator.",
      "Modality changes restricted after an appointment is created.",
      "Enhanced multi-field search: Medicare number, mobile number, patient name, and date of birth.",
      "Ability to send patient preparation guidelines via SMS.",
    ],
  },
  {
    section: "Visits",
    items: [
      "Visit details can now be updated after verification or claim rejection.",
      "New 'Distributed' status when reports are sent via EDI.",
      "EDI sending issues and discrepancies resolved.",
      "New case types added: MVIT and MRINOW.",
      "Radiscan VisitState and OrderStatus now synchronised and visible on the Unreported Visits page.",
      "Document validation now restricts uploads to PDF and JPG/JPEG only (PNG no longer permitted).",
      "Auto-refresh for attached documents enabled.",
    ],
  },
  {
    section: "Bug Fixes & Improvements",
    items: [
      "Improved reliability of SMS and email alerts.",
      "Resolved duplicate notification issues.",
    ],
  },
  {
    section: "Reports",
    items: [
      "Added resend EDI and FAX functionality in the Delivery Report page.",
      "Fixed EDI report sending issues.",
      "HL7 reports now include YourScan-generated image links.",
      "Added Health-link workflow support in RadspaceMOService.",
    ],
  },
  {
    section: "Standardised Name Display Format",
    items: [
      "User names are now consistently displayed as Lastname, Firstname across the system.",
    ],
  },
  {
    section: "QuickCode",
    items: [
      "Enhanced QuickCode search—now supports exam code, description, and exam type.",
      "Added Medicare-integrated QuickCode allowing configuration of modifiers that auto-populate during billing.",
    ],
  },
  // {
  //   section: "My Health Record Integration",
  //   items: [
  //     "Integrated with My Health Record (MHR), enabling reports to be manually pushed or removed.",
  //     "Introduced a consent toggle to control when reports are shared with My Health Record.",
  //   ],
  // },
];